import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import SectionHeading from "../components/site/SectionHeading";
import { IMG } from "../lib/media";

const Process = () => {
  const { t } = useLang();
  return (
    <div data-testid="page-process">
      <section className="pt-40 pb-20 border-b border-white/5 relative overflow-hidden">
        <img src={IMG.blueprint} alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0C]/70 to-[#0A0A0C]" />
        <div className="relative container-x">
          <SectionHeading overline={t.process.overline} title={t.process.title} />
        </div>
      </section>

      <section className="section-y">
        <div className="container-x grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="rounded-xl overflow-hidden hairline sticky top-24">
              <img src={IMG.blueprint} alt="Architectural blueprint" className="w-full h-[480px] object-cover" />
            </div>
          </div>
          <ol className="lg:col-span-7 space-y-5">
            {t.process.steps.map((s, i) => (
              <li
                key={i}
                className="hairline hairline-hover rounded-xl p-7 bg-[#141417] card-lift"
                data-testid={`process-step-${i}`}
              >
                <div className="flex items-start gap-6">
                  <div className="font-display text-5xl font-extralight text-[#0055FF] leading-none">{s.n}</div>
                  <div>
                    <h3 className="font-display text-2xl text-white font-light">{s.t}</h3>
                    <p className="mt-3 text-white/65 leading-relaxed">{s.d}</p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="border-t border-white/5 bg-[#0C0C0F]">
        <div className="container-x py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <h3 className="font-display text-2xl md:text-3xl font-light max-w-xl">
            Step one: a 20-minute conversation about your project.
          </h3>
          <Link to="/contact" className="btn-primary">Start Consultation</Link>
        </div>
      </section>
    </div>
  );
};

export default Process;
